<template>
    <header class="header" :class="{fixed: fixed}">
        <div class="heads">
            <div class="heads_con">
                <div style="float: left;">您好，{{$siteConfig.title}}欢迎您！</div> 
                <div style="float: right;">客服电话：{{$siteConfig.tel}}</div>
            </div>
        </div>

        <div class="content">
            <img 
                class="logo header-com" 
                v-if="$siteConfig.logoUrl"
                :src="$siteConfig.logoUrl"
                :style="$siteConfig.logoStyle ? $siteConfig.logoStyle : ''"
            />
            <label 
                class="logo logoTetxt header-com" 
                v-else
            >
                {{$siteConfig.title}}
            </label>

            <div class="nav-list header-com" :style="{marginLeft: $siteConfig.planName == 'sdzh'? '40px':'68px'}">
                <template v-for="(item, index) in $siteNav">
                    <a 
                    class="nav-item" 
                    :key="index"
                    :href="item.href"
                    :class="{active: isActive(item),'ml-24': $siteName === 'nm','ml-35': $siteName === 'sdzh'}"
                    @click="clickHandler($event, item.click)"
                    >
                        {{item.title}}
                    </a>
                </template>
            </div>
            <div class="search">
                <el-input v-model="searchText" class="input-search" size="middle">
                    <el-button 
                        placeholder="请输入搜索信息" 
                        slot="append" 
                        @click="searchHandler">
                            搜索
                    </el-button>
                </el-input>
            </div>
        </div>

        <slot></slot>
    </header>
</template>

<script>

export default {
    components: {
        
    },
    props: {
        theme: {
            type: String,
            default: ''
        },
        fixed: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            useSearchDeal: false,   //是否使用 (查交易中心、查公告、查企业) 搜索组件
            searchText:'',
        }
    },
    computed: {
        
    },
    methods: {
        isActive(item) {
            var path = this.$route.path,
                href = item.href,
                activeReg = item.activeReg;

            if (href === path) {
                return true;
            }

            if (path === href) {
                return true;
            }

            if (activeReg && activeReg.test(path)) {
                return true;
            }

            return false;
        },
        clickHandler(e, cb) {
            if (cb) {
                e.preventDefault();
                
                var fun = new Function(cb);
                fun.call(this);
            }
        },
        // 搜索
        searchHandler() {
            this.goto({
                path: '/business',
                query: {
                    searchcontent: this.searchText,
                },
            })
        },
    },
    mounted: function() {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '@css/var.scss';
    
	.header{
		overflow: hidden;
		cursor: default;
        background: white;
        box-shadow: 0px 1px 6px 0px rgba(61, 126, 255, 0.15);

        .content{
            padding: 5px 0;
        }

        &.fixed{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            z-index: 10000;
            min-width: 1200px;
        }

        .heads{
            width: 100%;
            height:40px;
            line-height: 40px;
            background: #fff;
            border-bottom: 1px solid #e6e6e6;
        }
        .heads_con{
            width: 1200px;
            margin:0 auto;
        }

		.header-com{ 
			float:left;
		}

		img.logo{
            max-width: 280px;
            // width: 236px;
			height: 45px;
			margin: 8px 0;
		}

        .logoTetxt{
            font-size: 24px;
            color:#000;
            font-weight: bold;
            margin-top:16px;
        }

		.nav-list{
			font-size: 16px;
			overflow: hidden;
            padding: 23px 0;
            margin-left: 68px;

			.nav-item{
				float: left;
				cursor: pointer;
				color: #333;
                position: relative;
                line-height: 1em;
                font-size: inherit;

				&:hover{
					color: $primaryColor;
				}

				& + .nav-item{
					margin-left: 44px;
				}

				&.active{
					font-weight: bolder;
                    color: $primaryColor;
                    position: relative;

                    &:after{
                        content: '';
                        display: block;
                        width: 100%;
                        height: 4px;
                        position: absolute;
                        left: 0;
                        bottom: -23px;
                        background-color: $primaryColor;
                    }
				}
			}

            .ml-24{
                & + .nav-item{
					margin-left: 14px;
				}
            }

            .ml-35{
                & + .nav-item{
					margin-left: 35px;
				}
            }
		}
        .search{ 
            float:right;
            margin-top: 15px;
            ::v-deep .el-input__inner{ height: 30px; }
            ::v-deep .el-button{ 
                background: #2252e7; 
                color: #fff; 
                padding: 8px 20px; 
                border-top-left-radius: 0; 
                border-bottom-left-radius: 0;
            }
        }
	}

    .child-item{
        color: #333333;
    }
</style>
